import React from 'react'
import ReactDOM from 'react-dom'
import '../../globals/scss/style.scss'
import App from './app'
import './styles/main.scss'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { getReCaptchaSitekey } from '../../utils/config'
import { Provider } from 'react-redux'
import { store } from './store/store'

const siteKey = getReCaptchaSitekey(window.location.hostname)

ReactDOM.render(
  <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleReCaptchaProvider>,
  document.getElementById('main'),
)
